/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Measure_Unit_Profile_PerInputs */

const en_measure_unit_profile_per = /** @type {(inputs: Measure_Unit_Profile_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per profile`)
};

const zh_hans1_measure_unit_profile_per = /** @type {(inputs: Measure_Unit_Profile_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每个主页`)
};

const pt_br2_measure_unit_profile_per = /** @type {(inputs: Measure_Unit_Profile_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por perfil`)
};

const es_measure_unit_profile_per = /** @type {(inputs: Measure_Unit_Profile_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por perfil`)
};

const fr_measure_unit_profile_per = /** @type {(inputs: Measure_Unit_Profile_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`par profil`)
};

const de_measure_unit_profile_per = /** @type {(inputs: Measure_Unit_Profile_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pro Profil`)
};

const ru_measure_unit_profile_per = /** @type {(inputs: Measure_Unit_Profile_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`за профиль`)
};

const it_measure_unit_profile_per = /** @type {(inputs: Measure_Unit_Profile_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per profilo`)
};

/**
* | output |
* | --- |
* | "per profile" |
*
* @param {Measure_Unit_Profile_PerInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_unit_profile_per = /** @type {((inputs?: Measure_Unit_Profile_PerInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Unit_Profile_PerInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_unit_profile_per(inputs)
	if (locale === "pt-BR") return pt_br2_measure_unit_profile_per(inputs)
	if (locale === "es") return es_measure_unit_profile_per(inputs)
	if (locale === "fr") return fr_measure_unit_profile_per(inputs)
	if (locale === "de") return de_measure_unit_profile_per(inputs)
	if (locale === "ru") return ru_measure_unit_profile_per(inputs)
	if (locale === "it") return it_measure_unit_profile_per(inputs)
	return en_measure_unit_profile_per(inputs)
});